import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { NavLinks } from './NavLinks';
import { COMPANY } from '../../utils/constants';

export function Navbar() {
  return (
    <nav className="fixed w-full z-50 bg-white/90 backdrop-blur-sm shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-2">
            <Compass className="w-8 h-8 text-[#C4A484]" />
            <span className="text-2xl font-playfair">{COMPANY.name}</span>
          </Link>
          <NavLinks />
        </div>
      </div>
    </nav>
  );
}